import {alertResponseError, alertResponseSuccess} from "../../../helpers/general";
import OrganizationService from "../../../services/OrganizationService";
import {ERRORS_CODE} from "../../../const/error_code";
import {PLAN_ID} from "../../../const/common";
import SubscriptionService from "../../../services/Subscription.service";
import * as Swal from "sweetalert2";
export default {
    data() {
        return {
            plans: {},
            planId: PLAN_ID,
            max_volume: 1,
        }
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        this.getListPlan();
    },
    methods: {
        getListPlan() {
            SubscriptionService.getPlans().then((response) => {
                if (response.data.success) {
                    this.plans = response.data.data.results;
                }
            }).catch((error) => {
                console.log(error);
            })
        },
        deletePlan(planId) {
            console.log("Delete: ", planId);
            Swal.fire({
                text: this.$t('subscription.confirm_delete'),
                icon: 'info',
                showCloseButton: true,
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: this.$t('common.yes'),
                cancelButtonText: this.$t('common.no'),
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    SubscriptionService.deleteSubcription().then((response) => {
                        if (response.data.success) {
                            alertResponseSuccess(this.$t('common_message.delete_success'));
                            this.getListPlan();
                        }
                    }).catch((error) => {
                        alertResponseError(error);
                    });
                }
            });
        },
        checkOrganization(plan) {
            OrganizationService.getDetailOrganization().then((response) => {
                if (response.data.success) {
                    this.$router.push({name: 'subscription-registration', params: { plan_type: plan.id }, query: { volume: plan.max_volume, price: plan.price  }} );
                }
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_NOT_FOUND) {
                    return alertResponseError(this.$t("message_error.CAN_NOT_START_PLAN")).then((value) => {
                        if (value) {
                            this.$router.push({name: 'Organization'});
                        }
                    });
                } else {
                    return alertResponseError(error);
                }

            })
        },
        changePlan(planId) {
            return SubscriptionService.changePlan(planId).then((response) => {
                if (response.data.success) {
                    alertResponseSuccess(this.$t('common_message.update_success'));
                    this.getListPlan();
                }
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_COUNT_GREATER_THAN_PLAN_MAX_VOLUME) {
                    return Swal.fire({
                        text: this.$t('subscription.downgrade_error', {max_volume: this.max_volume}),
                        icon: 'warning',
                        showCloseButton: true,
                        confirmButtonText: this.$t('subscription.btn_ok'),
                    }).then(() => {
                        this.$router.push({name: 'aimodel'})
                    })
                }
            })
        }
    }
}
